import React, { useState, useEffect } from 'react';
import ArticleCard from './ArticleCard';
import { getAllArticles } from '../utils/articleStorage';
import './HomePage.css';

function HomePage() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadArticles();
  }, []);

  const loadArticles = async () => {
    setLoading(true);
    const fetchedArticles = await getAllArticles();
    setArticles(fetchedArticles);
    setLoading(false);
  };

  if (loading) {
    return (
      <div className="homepage">
        <div className="articles-container">
          <p className="no-articles">loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="homepage">
      <div className="articles-container">
        {articles.length === 0 ? (
          <p className="no-articles">no articles yet.</p>
        ) : (
          articles.map((article) => (
            <ArticleCard
              key={article.id}
              id={article.id}
              title={article.title}
              description={article.description}
              date={article.date}
            />
          ))
        )}
      </div>
    </div>
  );
}

export default HomePage;
